import {
  intersectionWatcher,
  delayOffset,
  shouldAnimate,
} from "@/lib/animation";
import { qsa } from "@fluorescent/dom";

const selectors = {
  sectionIntro: ".animation--section-introduction > *",
  slide: ".featured-collection-row__slide",
};

export default node => {
  if (!shouldAnimate(node)) return;

  const { textAlignment } = node.dataset;
  const columns = parseInt(node.dataset.columns);
  const slides = qsa(selectors.slide, node);

  // Depending on the layout choose which elements to animate and in what order
  if (textAlignment === "right") {
    delayOffset(node, [
      `${selectors.slide}:nth-child(n+${slides.length - columns + 1})`,
      selectors.sectionIntro,
    ]);
  } else {
    delayOffset(node, [
      selectors.sectionIntro,
      `${selectors.slide}:nth-child(-n+${columns})`,
    ]);
  }

  const observer = intersectionWatcher(node, true);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
